import alert from 'assets/alerttriangle.svg';
import disapproved from 'assets/errorcircle.svg';

interface IMidiaInfoValue {
  value: string;
  result: string;
}

export interface IMidiaInfoItem {
  resolucao: IMidiaInfoValue;
  videobitrate: IMidiaInfoValue;
  format: IMidiaInfoValue;
  formatprofile: IMidiaInfoValue;
  audiotrackcount: IMidiaInfoValue;
  scantype: IMidiaInfoValue;
  scanorder: IMidiaInfoValue;
  audiocodec: IMidiaInfoValue;
  audiosamplingrate: IMidiaInfoValue;
  audiobitdepth: IMidiaInfoValue;
  tracks: {
    [key: string]: IMidiaInfoValue;
  }[];
  dfndf: IMidiaInfoValue;
  cceia608: IMidiaInfoValue;
  cceia708: IMidiaInfoValue;
  loudness: IMidiaInfoValue;
  timecode: IMidiaInfoValue;
}

function getIcon(value: string) {
  switch (value) {
    case 'ressalva':
      return `<img color='warn' src='${alert}'/>`;
    case 'reprovado':
      return `<img src='${disapproved}'/>`;
    default:
      return `<span style="width:29px"/>`;
  }
}

export const midiainfo = (
  status: string,
  midiainfo: IMidiaInfoItem,
): { type: string; contentHTML: string; confirmButtonText: string } => {
  let infoIcon = '';
  switch (status) {
    case 'aprovado':
      infoIcon = 'success';
      break;
    case 'reprovado':
      infoIcon = 'error';
      break;
    default:
      infoIcon = 'info';
      break;
  }

  const tracks = midiainfo.tracks.map(
    (track, index) =>
      `<li key='${index}'>TRACK${index + 1} <strong>${
        track[`track${index + 1}`].value
      }${getIcon(track[`track${index + 1}`].result)}</strong></li>`,
  );

  // const tracks = Object.values(midiainfo.tracks).map(
  //   (track, index) =>
  //     `<li key='${index}'>TRACK${index + 1} <strong>${track.value}${getIcon(
  //       track.result,
  //     )}</strong></li>`,
  // );

  const contentHTML =
    `<div><ul>` +
    '<li>' +
    `RESOLUÇÃO: <strong>${midiainfo.resolucao.value}${getIcon(
      midiainfo.resolucao.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `VIDEOBTRATE: <strong>${midiainfo.videobitrate.value}${getIcon(
      midiainfo.videobitrate.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `FORMAT: <strong>${midiainfo.format.value}${getIcon(
      midiainfo.format.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `FORMATPROFILE: <strong>${midiainfo.formatprofile.value}${getIcon(
      midiainfo.timecode.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `AUDIOTRACKCOUNT: <strong>${midiainfo.audiotrackcount.value}${getIcon(
      midiainfo.audiotrackcount.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `SCANTYPE: <strong>${midiainfo.scantype.value}${getIcon(
      midiainfo.scantype.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `SCANORDER: <strong>${midiainfo.scanorder.value}${getIcon(
      midiainfo.scanorder.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `AUDIOCODEC: <strong>${midiainfo.audiocodec.value} ${getIcon(
      midiainfo.audiocodec.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `AUDIOSAMPLINGRATE: <strong>${midiainfo.audiosamplingrate.value} ${getIcon(
      midiainfo.audiosamplingrate.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `AUDIOBITDEPTH: <strong>${midiainfo.audiobitdepth.value} ${getIcon(
      midiainfo.audiobitdepth.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `TIMECODE: <strong>${midiainfo.timecode.value} ${getIcon(
      midiainfo.timecode.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `DF/NDF: <strong>${midiainfo.dfndf.value} ${getIcon(
      midiainfo.dfndf.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `CCEIA608: <strong>${midiainfo.cceia608.value ? 'SIM' : 'NÃO'}${getIcon(
      midiainfo.cceia608.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `CCEIA708: <strong>${midiainfo.cceia708.value ? 'SIM' : 'NÃO'}${getIcon(
      midiainfo.cceia708.result,
    )}</strong>` +
    '</li>' +
    '<li>' +
    `LOUDNESS: <strong>${midiainfo.loudness.value} LUFS ${getIcon(
      midiainfo.loudness.result,
    )}</strong>` +
    '</li>' +
    `</ul>` +
    `<ul>` +
    tracks.toString().replace(/,/g, '') +
    `<ul></div > `;
  const options = {
    type: infoIcon,
    contentHTML,
    cancelButtonText: 'NÃO',
    showCancelButton: false,
    showConfirmButton: true,
    confirmButtonText: 'FECHAR',
  };
  return options;
};

export default midiainfo;
